import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, API_ENDPOINTS } from '@core';
import {
  DrywallPricingDrawerResponse,
  DrywallPricingDrawerSaveRequest,
  DrywallPricingDrawerSaveResponse,
  DrywallRoomHeightsResponse,
  DrywallRoomHeightsSaveRequest,
  DrywallRoomHeightsSaveResponse,
} from '@core/models/project.models';
import { ApiResponse } from '@core/models/api.models';

@Injectable()
export class DrywallApiService {
  private readonly api = inject(ApiService);

  getPricingDrawer(projectId: number): Observable<ApiResponse<DrywallPricingDrawerResponse>> {
    return this.api.get<DrywallPricingDrawerResponse>(API_ENDPOINTS.project.pricingDrawerDrywall(projectId));
  }

  savePricingDrawer(
    projectId: number,
    payload: DrywallPricingDrawerSaveRequest,
  ): Observable<ApiResponse<DrywallPricingDrawerSaveResponse>> {
    return this.api.post<DrywallPricingDrawerSaveResponse>(
      API_ENDPOINTS.project.pricingDrawerDrywall(projectId),
      payload,
    );
  }

  getRoomHeights(projectId: number): Observable<ApiResponse<DrywallRoomHeightsResponse>> {
    return this.api.get<DrywallRoomHeightsResponse>(API_ENDPOINTS.project.drywallRoomHeights(projectId));
  }

  saveRoomHeights(
    projectId: number,
    payload: DrywallRoomHeightsSaveRequest,
  ): Observable<ApiResponse<DrywallRoomHeightsSaveResponse>> {
    return this.api.post<DrywallRoomHeightsSaveResponse>(
      API_ENDPOINTS.project.drywallRoomHeights(projectId),
      payload,
    );
  }
}
